import { render } from "./socialLink.vue?vue&type=template&id=1f939782&scoped=true"
const script = {}

import "./socialLink.vue?vue&type=style&index=0&id=1f939782&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f939782"]])

export default __exports__